module.exports = __webpack_public_path__ + "media/MyAudio_10.bbd987f5.mp3";